<template>
  <div>
    <CheckListTableComponent
      typeName='巡回清掃'
      :type=2
      routerName='RoundScheduleListByStaff'
      :siteLocation="siteLocation"
      :rls="rls"
    >
    </CheckListTableComponent>
  </div>
</template>

<script>
import CheckListTableComponent from '../components/RoundCheckListTableComponent.vue'
import PageModel from '../../main/pages/PageModel.vue'

export default {
  extends: PageModel,
  components: {
    CheckListTableComponent,
  },

  props: {
    // 位置情報
    siteLocation: {
      type: Object
    },
    // RLSの情報
    rls: {
      type: Object
    }
  },
}
</script>